import * as React from "react";
import type { SVGProps } from "react";
const SvgClocksWithArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    viewBox="0 0 24 25" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6.375 12.5-2.25 2.25-2.25-2.25"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.125 12.5c0 .694.086 1.366.235 2.015M22.125 12.5a9 9 0 0 0-9-9 9 9 0 0 0-9 9M13.125 21.5a9 9 0 0 0 9-9M5.754 17.656a8.98 8.98 0 0 0 7.37 3.845"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m16.496 15.37-3.652-2.173V8.484"
    />
  </svg>
);
export default SvgClocksWithArrow;
